// extracted by mini-css-extract-plugin
module.exports = {"toggle-input-block":"src-components-molecules-ToggleInputBlock-___style__toggle-input-block___34qVO"};